import React from "react";
import ComplianceDocument from "../components/ui/ComplianceDocument";

export default function PhotoConsentPage(): React.JSX.Element {
    return (
        <ComplianceDocument
            slug="photo-consent"
            title="Photo Processing Consent (Biometric Data)"
            description={
                <span>
                    This consent explains how <strong>kivo.skin</strong> processes photos of your face,
                    including biometric and sensitive data under GDPR Article 9.
                </span>
            }
        />
    );
}
